module.exports = __webpack_public_path__ + "assets/img/slide01.b84c6d00.svg";